import { AnalyticsMetaKeys as key } from '../../../../../../services/analytics/formatters/meta-keys'
import { AttributeFormatter } from '../../formatters/attribute'
import { PageEvents } from '../../page-events'
import { MparticleEvent } from '../mparticle-event'

const mParticleEvents: any = new PageEvents()

export class VideoCenter extends MparticleEvent {

    public attributeFormatter = new AttributeFormatter()
    /**
     * Handle a widget click event
     */
    public handle(): void {

        const attrs = [
            key.DOMAIN,
            key.VID_ID,
            key.URL,
            key.OUTFIT,
            key.OUTFIT_POS
        ]

        const data = this.attributeFormatter.format(
            attrs,
            {
                ...this.metaProperties,
                ...this.attributeFormatter.vidCenterAttrformat(this.getProperties())
            }
        )

        mParticleEvents.logEvent(
            PageEvents.mpEventName.VideoCenter,
            PageEvents.mpEventType.Navigation,
            data
        )
    }
}
